/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * @author  NataliaBalaba
 */
export default class Operator extends Enum{

	static  UNION = Operator.newLiteral("UNION");

	static  EXCEPT = Operator.newLiteral("EXCEPT");

	static  INTERSECT = Operator.newLiteral("INTERSECT");

	static  JOIN = Operator.newLiteral("JOIN");

	static  SQL = Operator.newLiteral("SQL");

	static  PLAIN = Operator.newLiteral("PLAIN");

	static  VIEW = Operator.newLiteral("VIEW");

	static  METRIC_DEFINITION = Operator.newLiteral("METRIC_DEFINITION");

	static  METRIC_INSTANCE = Operator.newLiteral("METRIC_INSTANCE");



	value() {
		return this.name();
	}
}


// WEBPACK FOOTER //
// ./src/generated/Operator.js